<template>
  <div class="hero-wrapper pt-100 pb-100">
    <div class="container flex items-center justify-between mb-flex-wrap">
      <div class="maxw-685 wp-100">
        <h1 class="mb-20 fw-700 fs-48 lh-52 cream mb-fs-28 mb-lh-32"><slot name="title"></slot></h1>
        <div class="mb-mb-30 fw-500 fs-16 lh-24 cream"><slot name="sub-title"></slot></div>
      </div>
      <div><slot name="button"></slot></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
// (Green photography-overlay removed 2026-07-15, product decision — the
// consumer-supplied .bg-hero photo renders natural, as pre-migration.)
h1 {
  letter-spacing: -0.04em; // v2 display tracking (§Typography Scale L94)
}
@include phone {
  .hero-wrapper {
    background-position: center;
    background-size: cover;
    min-height: 340px; // grow to fit content on narrow screens (was fixed 340px, which clipped the CTA below ~420px)
  }
}
</style>
